const SUFFIX = "Mijn Repowered"
const SEPARATOR = " | "

export default function setPageTitleFromRoute(route) {
  const title = route.meta.title
  let fullTitle = ""
  if (title) {
    if (typeof title === "string") {
      fullTitle += title + SEPARATOR
    } else if (typeof title === "object") {
      fullTitle += title[route.path] + SEPARATOR
    } else {
      // Do nothing
    }
  }
  fullTitle += SUFFIX
  window.document.title = fullTitle
}
